<template>
  <v-file-input ref="input" class="app-file-input" outlined dense prepend-icon="" v-bind="$attrs" v-on="$listeners">
    <template v-for="(_, slot) in $scopedSlots" #[slot]="scope">
      <slot :name="slot" v-bind="scope || {}" />
    </template>

    <!-- NÃO renomear `plainSlot` para `slot`: o compilador indexa `el.scopedSlots` pela expressão do
         nome dinâmico, então dois v-for escritos `#[slot]` colidem nessa chave e o segundo descarta o
         primeiro EM TEMPO DE COMPILAÇÃO, sumindo com todos os slots COM escopo. Sem erro nem warning. -->
    <template v-for="(_, plainSlot) in $slots" #[plainSlot]>
      <slot :name="plainSlot" />
    </template>
  </v-file-input>
</template>

<script>
export default {
  name: 'AppFileInput',

  methods: {
    validate() {
      return this.$refs.input.validate()
    },

    reset() {
      return this.$refs.input.reset()
    },

    resetValidation() {
      return this.$refs.input.resetValidation()
    },
  },
}
</script>

<style scoped>
.app-file-input ::v-deep .v-input__slot {
  border-radius: 10px !important;
}

.app-file-input ::v-deep fieldset {
  border-radius: inherit !important;
}
</style>
